import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-9c20edbc")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("button", {
    class: "thunbnail",
    disabled: 0 == _ctx.item.imgPath.length,
    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.item.clickAction && _ctx.item.clickAction(...args)))
  }, [
    (0 < _ctx.item.imgPath.length)
      ? (_openBlock(), _createBlock("img", {
          key: 0,
          class: "thunbnail-img",
          src: _ctx.item.imgPath
        }, null, 8, ["src"]))
      : _createCommentVNode("", true)
  ], 8, ["disabled"]))
})